import { isFuture, isPast } from 'date-fns'

export const isNodes = userPlan => userPlan.serviceTypes.includes('nodes')

export const isCluster = userPlan => userPlan.serviceTypes.includes('cluster')

export const isActive = userPlan =>
  userPlan.startsAt && isPast(userPlan.startsAt) && isFuture(userPlan.expiresAt)

export const isPaid = userPlan => Boolean(userPlan.startsAt)

export const isPending = userPlan =>
  !userPlan.expiresAt &&
  !userPlan.startsAt &&
  !(userPlan.payments || []).some(({ status }) => status === 'paid')

export const isRenewal = userPlan => Boolean(userPlan.renewedFrom)

export const isFutureRenewal = userPlan =>
  isPaid(userPlan) && isFuture(userPlan.startsAt) && isRenewal(userPlan)

export const isUpgrade = userPlan => Boolean(userPlan.upgradedFrom)

export const isProcessingPayment = userPlan =>
  (userPlan.payments || []).some(
    ({ status }) => status === 'processing' || status === 'paid'
  )

export const isFree = userPlan => !userPlan.amount
